import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { NamirasoftBalanceServer } from "namirasoft-balance";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { BalanceLayout } from "./BalanceLayout";
import { BalanceRoutes } from "./BalanceRoutes";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import SummaryListPage from "./pages/SummaryListPage";
import SummaryViewPage from "./pages/SummaryViewPage";
import TransactionListPage from "./pages/TransactionListPage";
import TransactionViewPage from "./pages/TransactionViewPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_BALANCE}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_BALANCE = new EnvService("REACT_APP_BASE_URL_BALANCE", true).getString();
            let balance = new NamirasoftBalanceServer(REACT_APP_BASE_URL_BALANCE, result.account.token_manager, result.notifier.onError);
            let servers = { balance };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows => (<Routes>
                        <Route path={BalanceRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                        <Route path={BalanceRoutes.SummaryList(":asset_id")} element={<SummaryListPage {...result} servers={servers} />} />
                        <Route path={BalanceRoutes.SummaryView(":id")} element={<SummaryViewPage {...result} servers={servers} />} />

                        <Route path={BalanceRoutes.TransactionList(":asset_id")} element={<TransactionListPage {...result} servers={servers} />} />
                        <Route path={BalanceRoutes.TransactionView(":id")} element={<TransactionViewPage {...result} servers={servers} />} />

                        {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                        <Route path="*" element={<NSNotFoundPage />} />
                    </Routes >))}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={BalanceRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <BalanceLayout
                {...props}
            >
                {props.children}
            </BalanceLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;